var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("source", {
    attrs: { src: "#", srcset: _vm.src, media: _vm.media, type: _vm.typeImage },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }